import React from 'react';
import PropTypes from 'prop-types';
import CustomerSignatureSection from '../../../containers/renewals/UnauthedRenewalPageWrapper/CustomerSignatureSection/CustomerSignatureSection';
import './CustomerSignaturePage.css';
import { imageForDisplay } from '../../../../utils/utils';
import { Button } from '@material-ui/core';
import { injectIntl } from 'react-intl';
import { intlText } from '../../../../utils/text-util';
import { withRouter } from 'react-router-dom';

const CustomerSignaturePage = (props) => (
  <div>
    <div>
      <h1 className="customer-renewal-view-logo">
        <img src={props.logo} alt="C3 Link" />
      </h1>
    </div>
    <div className="col-xs-8 m-b-15 signature-page">
      <CustomerSignatureSection
        signatureImage={imageForDisplay(props.renewalSignature.signatureImage)}
        fullName={props.renewalSignature.fullName}
        email={props.renewalSignature.email}
        onSignatureChange={props.onSignatureChange}
        onFullNameChange={props.onFullNameChange}
        onEmailChange={props.onEmailChange}
        enabled={props.enabled}
        invalidFields={props.invalidFields}
        languageCode={props.customer.languageCode}
      />
      {props.enabled ? (
        <div className="customer-signature-element-wrapper approve-button-wrapper">
          <Button
            onClick={props.onSubmit}
            className="approve-button"
            disabled={!props.canSubmit}
          >
            {intlText(props, 'action.approve')}
          </Button>
        </div>
      ) : null}
    </div>
  </div>
);

CustomerSignaturePage.propTypes = {
  customer: PropTypes.object.isRequired,
  renewal: PropTypes.object.isRequired,
  renewalSignature: PropTypes.object.isRequired,
  onSignatureChange: PropTypes.func.isRequired,
  onFullNameChange: PropTypes.func.isRequired,
  onEmailChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  canSubmit: PropTypes.bool.isRequired,
  enabled: PropTypes.bool.isRequired,
  invalidFields: PropTypes.array.isRequired
};

export default withRouter(injectIntl(CustomerSignaturePage));
